import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
  Container,
  Heading,
  HStack
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import adminApi from '../../services/adminApi';

function CreateConsultant() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formData.password !== formData.confirmPassword) {
      toast({
        title: 'Fejl',
        description: 'Adgangskoderne matcher ikke',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }

    try {
      await adminApi.createConsultant({
        name: formData.name,
        email: formData.email,
        password: formData.password
      });

      toast({
        title: 'Konsulent oprettet',
        description: 'Konsulenten er blevet oprettet succesfuldt',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      navigate('/admin', { state: { showConsultants: true } });
    } catch (error) {
      toast({
        title: 'Fejl ved oprettelse',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxW="container.md" py={5}>
      <VStack spacing={5} align="stretch">
        <HStack justify="space-between">
          <Heading size="lg">Opret ny konsulent</Heading>
          <Button onClick={() => navigate('/admin')}>Tilbage</Button>
        </HStack>

        <Box as="form" onSubmit={handleSubmit}>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Navn</FormLabel>
              <Input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Indtast navn"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Indtast email"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Adgangskode</FormLabel>
              <Input
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Indtast adgangskode"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Bekræft adgangskode</FormLabel>
              <Input
                name="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Bekræft adgangskode"
              />
            </FormControl>

            <Button
              type="submit"
              colorScheme="blue"
              isLoading={loading}
              loadingText="Opretter..."
              width="full"
            >
              Opret konsulent
            </Button>
          </VStack>
        </Box>
      </VStack>
    </Container>
  );
}

export default CreateConsultant; 